import React, {useContext} from 'react';
import HeadingAndExpandableBody from '../UI/HeadingAndExpandableBody';
import {Context} from '../../context';
import Button from '../UI/Button';
import {Link} from 'react-router-dom';

function RecoverAccount(props) {
  const {localeText} = useContext(Context);

  return (
    <HeadingAndExpandableBody
      headingAndExpandableBodyId='account-recovery'
      heading={localeText('rw_header_recover_account', 'Recover Account')}
      expanded={props.expanded}
    >
      <p>
        {localeText(
          'rw_msg_recover_acc',
          'Recover Account from previous system'
        )}
      </p>
      <Link to='/migration'>
        <Button>
          {localeText('rw_button_begin_recovery', 'Begin Recovery')}
        </Button>
      </Link>
    </HeadingAndExpandableBody>
  );
}

export default RecoverAccount;
